export default __webpack_public_path__ + "static/media/pabst-key-advantages.de02c194.png";